import { ISODateRange } from 'shared/src/date-string-utils/types';
import React, { createContext, ReactNode, useContext, useMemo } from 'react';

export type ProposalInfo = {
  campaign_dates: ISODateRange;
  target_margin: number | null;
  planned_margin: number | null;
  proposal_price: number;
  allocated_price: number;
  is_agency_markup: boolean;
  is_referral_commission: boolean;
  agency_markup_rate: number;
  referral_commission_rate: number;
};

const ProposalInfo = createContext<ProposalInfo | null>(null);

type Props = {
  proposalInfo: ProposalInfo;
  children: ReactNode;
};

export function ProposalInfoProvider({ proposalInfo, children }: Props) {
  const value = useMemo(() => ({ ...proposalInfo }), [proposalInfo]);
  return <ProposalInfo value={value}>{children}</ProposalInfo>;
}

// This provider is mainly to transition from the old CombinedStrategy context to the new proposal context
// Can be removed once we fully move over to proposals and executions
export function useProposalInfo() {
  const value = useContext(ProposalInfo);
  if (!value) {
    throw new Error('useProposalInfo must be used within a ProposalInfoProvider');
  }
  return value;
}
